import React from 'react'
import BaseStep from '../BaseStep'
import CardSelectable from '../commons/CardSelectable'
import Back from '../commons/Back'
import GenericIcon from 'components/GenericIcon'

class LoanTarget extends BaseStep {

  onClick = (answer) => {
    this.props.onChoice({ loanTarget: answer })
  }

  question = () => {
    return I18n.t(`onboarding.loan_target.${this.props.loanPurpose}.question`)
  }

  render() {
    return (
      <div ref={ (ref) => this.cardsContainer = ref } >
        <h3 className="onboarding-title text-center">
          { this.question() }
        </h3>
        <div className="row">
          <div className="col-sm-6">
            <CardSelectable
              onClick={ () => this.onClick('own_home') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='homeGarage' />
              <h4>{ I18n.t(`onboarding.loan_target.${this.props.loanPurpose}.answer.own_home`) }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-6">
            <CardSelectable
              onClick={ () => this.onClick('investment') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='dollarShield' />
              <h4>{ I18n.t(`onboarding.loan_target.${this.props.loanPurpose}.answer.investment`) }</h4>
            </CardSelectable>
          </div>
        </div>
        <Back onGoBack={this.props.onGoBack} />
      </div>
    )
  }
}

export default LoanTarget;
